module.exports = __webpack_public_path__ + "static/media/spinner.faefc337.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spinner.svg
// module id = 1756
// module chunks = 2